// modules
import { DBDrop } from '@weblite/persist'
import { DB_NAME } from '$setup/persist'
import { showOperationFailedSnackbar } from '$comp/snackbars'
import { fullReload } from '$func/fullReload'
import { restoreSessionStorageOnSignOut } from '$hooks/after/signout.js'

export function synchronizePersist() {
  try {
    restoreSessionStorageOnSignOut()
    DBDrop(DB_NAME).then(() => {
      // TODO: create db
      fullReload()
    })
  } catch (e) {
    console.error('Failed to remove persist')
    showOperationFailedSnackbar(synchronizePersist)
  }
}
